<template>
  <div
    v-if="isFlagshipMode"
    class="vc-section vc-card vc-card--compact vc-transition-sound"
    :class="{ 'vc-transition-sound--collapsed': !isEnabled }"
  >
    <div class="vc-transition-sound__head">
      <span class="vc-transition-sound__title">过渡音效</span>
      <div class="vc-transition-sound__switch">
        <span class="vc-transition-sound__switch-label">{{ isEnabled ? '开启' : '关闭' }}</span>
        <i-switch v-model="callControl.transition_sound_enabled" />
      </div>
    </div>

    <div v-show="isEnabled" class="vc-transition-sound__body">
      <div class="vc-transition-sound-tip">
        <Icon type="ios-information-circle" class="vc-transition-sound-tip__icon" size="16" />
        <p class="vc-transition-sound-tip__text">
          自定义模式下，AI 回复前会播放短暂的键盘打字音效，模拟真人的思考与输入过程，让通话节奏更自然。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { PRESET_MODE } from '../../utils/tripleAccessHelpers'

export default {
  name: 'TransitionSoundSection',
  props: {
    callControl: {
      type: Object,
      required: true,
    },
    presetMode: {
      type: String,
      default: PRESET_MODE.ENGINE,
    },
  },
  computed: {
    isFlagshipMode() {
      return (this.presetMode || PRESET_MODE.ENGINE) === PRESET_MODE.CUSTOM
    },
    isEnabled() {
      return this.callControl.transition_sound_enabled === true
    },
  },
  watch: {
    isFlagshipMode: {
      immediate: true,
      handler(isFlagship) {
        if (isFlagship) {
          this.ensureFlagshipDefault()
        }
      },
    },
  },
  mounted() {
    this.ensureFlagshipDefault()
  },
  methods: {
    ensureFlagshipDefault() {
      if (!this.isFlagshipMode) return
      if (this.callControl.transition_sound_enabled == null) {
        this.$set(this.callControl, 'transition_sound_enabled', true)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './shared.scss';

.vc-section {
  margin-bottom: 16px;
}

.vc-card {
  background: #fff;
  border: 1px solid #e8eaec;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  padding: 20px;
}

.vc-card--compact {
  padding-bottom: 16px;
}

.vc-transition-sound {
  text-align: left;
}

.vc-transition-sound--collapsed {
  padding-bottom: 20px;

  .vc-transition-sound__head {
    margin-bottom: 0;
  }
}

.vc-transition-sound__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  min-height: 24px;
}

.vc-transition-sound__title {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  line-height: 24px;
}

.vc-transition-sound__switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.vc-transition-sound__switch-label {
  font-size: 13px;
  color: #595959;
  line-height: 24px;
}

.vc-transition-sound__body {
  padding-top: 0;
}

.vc-transition-sound-tip {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  background: #eef2ff;
  border: 1px solid #d6e0ff;
  border-radius: 4px;
  line-height: 1.5;

  &__icon {
    flex-shrink: 0;
    color: #5668f0;
    margin-top: 2px;
  }

  &__text {
    flex: 1;
    min-width: 0;
    margin: 0;
    font-size: 12px;
    color: #515a6e;
    text-align: left;
  }
}
</style>
